import React from 'react';
import PropTypes from 'prop-types';
import {EnvironmentOutlined} from '@/icons';
import styles from './index.module.less';

export default function LocationCard({title, address}) {
    return (
        <div className={styles.container}>
            <div className={styles.icon}>
                <EnvironmentOutlined />
                <div>位置</div>
            </div>
            <div className={styles.content}>
                <div className={styles.title}>{title}</div>
                <div className={styles.address}>{address}</div>
            </div>
        </div>
    );
}

LocationCard.propTypes = {
    title: PropTypes.string,
    address: PropTypes.string,
};
